import OfferApi from './offer-api';

export default OfferApi;
